import request from '@/plugin/axios'

// 管理员登录（仅谷歌验证器动态码，不再支持账号密码登录）
export function AccountLogin (data) {
  return request({
    url: '/admin/login',
    method: 'post',
    data
  })
}

// 旧版密码账号的一次性迁移绑定：用原密码换取谷歌验证器密钥（不签发 token）
export function TotpBootstrap (data) {
  return request({
    url: '/admin/totp/bootstrap',
    method: 'post',
    data
  })
}

// 重置某管理员的谷歌验证器（需登录），返回新密钥与二维码内容
export function TotpReset (data) {
  return request({
    url: '/admin/totp/reset',
    method: 'post',
    data
  })
}
